export default __webpack_public_path__ + "static/media/1_nemuru.fe3872a4.svg";